import { Col, Row } from 'react-bootstrap';
import ListaKeys from './ListaKeys';
import FormularioKeys from './FormularioKeys';
import { toast } from 'react-toastify';
import { ToastContent } from 'components/common/Toast';
import { IntegrationsBrandStatus } from './IntegrationsBrandStatus';

const Integracion = () => {
  const callToast = (title, body, time) =>
    toast(<ToastContent title={title} body={body} time={time} />);

  return (
    <>
      <Row className="g-3 mb-3">
        <Col xs={12} md={6} lg={4}>
          <FormularioKeys callToast={callToast} />
          <IntegrationsBrandStatus />
        </Col>
        <Col xs={12} md={6} lg={8}>
          <ListaKeys callToast={callToast} />
        </Col>
      </Row>
    </>
  );
};

export default Integracion;
